<template>
  <div class="row">

        <div class="col-12 col-md-7">
            <div class="s-lbl">
                Wähle dein Motiv
            </div>
            <div class="col-12 mb-4">
                <div class="d-flex motiv-radio">
                    <div>
                    <input type="radio" id="motiv1" name="motiv" value="1" v-model="model.design">
                    <label for="motiv1">
                        Motiv 1
                    </label>
                    </div>

                    <div>
                    <input type="radio" id="motiv2" name="motiv" value="2" v-model="model.design">
                    <label for="motiv2">
                        Motiv 2
                    </label>
                    </div>

                    <div>
                    <input type="radio" id="motiv3" name="motiv" value="3" v-model="model.design">
                    <label for="motiv3">
                        Motiv 3
                    </label>
                    </div>

                    <div>
                    <input type="radio" id="motiv4" name="motiv" value="4" v-model="model.design">
                    <label for="motiv4">
                        Motiv 4
                    </label>
                    </div>

                </div>



            </div>

            <div class="col-12  d-flex finish nav-buttons">
                <div class="row mr-4">
                    <div class="s-nav">
                        <router-link to="Three" class="back-btn">ZURÜCK</router-link>
                    </div>

                </div>
                <div class="row steps-wrapper">
                    <div class="steps-info">
                        Schritt 3 von 3
                    </div>
                </div>
                <div class="row">
                    <div class="s-nav">
                        <span class="btn" @click="addToCart()" href="">IN DEN WARENKORB</span>

                    </div>
                </div>
            </div>

        </div>

          <div class="col-12 col-md-5">
              <div class="cover-holder">
                  <img :src="'/slides/child-slides/motiv-'+model.design+'_1.jpg'">
                  <div class="cover-layer-text cover-name">
                      <span v-html="allModel.two.name"></span>
                  </div>

                  <div v-if="allModel.two.canvas !== null && !allModel.two.useil"  :class="'cover-layer-text cover-image cover-image-'+model.design">
                      <img :src="allModel.two.canvas" />
                  </div>
              </div>
          </div>




        <!--<div class="mt-4 pb-3 col-12">

            <a @click="addDate()" class="btn add-date">Termin hinzufügen</a>
        </div>-->



    </div>




</template>

<script>
import store from '@/store/store.js'

import '@vuepic/vue-datepicker/dist/main.css'
export default {
    components: {},
    name: 'step-five',

    data() {
        return {
            model: store.five,
            preModel: store.three,
            allModel: store,
            validate: false,
            inputErrors: [],

        }

    },
    watch: {
        model: {
            deep: true,
            handler() {

            }
        }
    },
    methods: {


    addToCart() {
        var xhr = new XMLHttpRequest();

        xhr.onreadystatechange = function () {
            if (this.readyState !== 4) return;

            if (this.status === 200) {
                window.location.replace('/checkout/cart');
            }
        };

        xhr.open('POST', '/addToCart/friend', true);
        xhr.setRequestHeader('Content-Type', 'application/json');


        this.allModel.two.canvas = '';




        xhr.send(JSON.stringify(this.allModel));
    },



    },
    mounted() {



    }
}
</script>

<style scoped>
  .star-container {
    justify-content: space-between;
      flex-wrap: wrap;
  }

  .star {
      border: solid 1px transparent;
  }

  .star.selected {
      border: solid 1px black;
  }

  .star-picture {
    /* height: 200px;
    border: black 1px solid; */
    padding: 0 10px;
  }

  .btn {
      background-color: black;
      color: white;
  }

  .star-picture img {
      width: 130px;
      height: auto;
  }

  .cover-layer-text {
      left: 133px;
      top: 34px;
      font-size: 10px;
  }

  .cover-image img {
      width: 58px;
      height: 59px;
  }

  .cover-image {
      left: 10px;
  }

  .cover-image-1 {
      left: 47px;
      top: 45px;
  }

  .cover-image-1 img {
      border-radius: 50%;
      width: 46px;
      height: 46px;
  }

  .cover-image-3 {
      left: 36px; top: 28px;
  }

  .cover-image-3 img {
      width: 58px;
      height: 78px;
      transform: rotate(-16deg);
  }

  .cover-image-4 {
      left: 45px;
      top: 58px;
  }

  .cover-image-4 img {
      border-radius: 50%;
      width: 46px;
      height: 46px;
  }

</style>
